"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdiProvider = void 0;
const scrypt_ts_1 = require("scrypt-ts");
const _1satApis_1 = require("./1satApis");
/**
 * The OrdProvider is backed by [gorillapool]{@link https://v3.ordinals.gorillapool.io/api/docs},
 *
 */
class OrdiProvider extends scrypt_ts_1.Provider {
    constructor(network) {
        super();
        this.network = scrypt_ts_1.bsv.Networks.mainnet;
        this.network = network || scrypt_ts_1.bsv.Networks.mainnet;
        this._provider = new scrypt_ts_1.DefaultProvider({
            network: this.network,
        });
    }
    isConnected() {
        return this._provider.isConnected();
    }
    async connect() {
        try {
            await this._provider.connect();
            this.emit('connected', true);
        }
        catch (error) {
            await this._provider.connect();
            this.emit('connected', false);
        }
        return Promise.resolve(this);
    }
    updateNetwork(network) {
        this.network = network;
        this._provider.updateNetwork(network);
        this.emit('networkChange', network);
    }
    getNetwork() {
        return this.network;
    }
    async sendRawTransaction(rawTxHex) {
        try {
            const txid = await this._provider.sendRawTransaction(rawTxHex);
            await _1satApis_1.OneSatApis.submitTx(txid, this.network);
            return txid;
        }
        catch (error) {
            throw new Error(`OrdProvider ERROR: ${error}`);
        }
    }
    async listUnspent(address, options) {
        return this._provider.listUnspent(address, options).then((utxos) => {
            return utxos.filter((u) => u.satoshis > 1);
        });
    }
    getBalance(address) {
        return this._provider.getBalance(address);
    }
    getTransaction(txHash) {
        return this._provider.getTransaction(txHash);
    }
    getFeePerKb() {
        return this._provider.getFeePerKb();
    }
}
exports.OrdiProvider = OrdiProvider;
